
import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {
    Container,
    Jumbotron
    
}from 'reactstrap';

export default class Home extends Component {
  render() {
    return (
      <div>
        <Container>
            <h3 className="foot">Tortilleria Rio | 1220 Dutton Ave, Waco, TX 76706</h3> 
        </Container>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js